import { render, staticRenderFns } from "./EstablishmentForm.vue?vue&type=template&id=555937fe"
import script from "./EstablishmentForm.vue?vue&type=script&lang=js"
export * from "./EstablishmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports